import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Checkbox from "@material-ui/core/Checkbox";
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// import Assignment from "@material-ui/icons/Assignment";
// import Face from "@material-ui/icons/Face";
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
// import Email from "@material-ui/icons/Email";
// import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import AddContactStepper from "./AddContactStepper.jsx"

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class AddOportunity extends React.Component {
  // constructor(props) {
  //   super(props);
  //   // this.state = {
  //   //   AddContactModal: false
  //   // };
  // }


  render() {
    const { classes } = this.props;
    return (
      <div>

        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + " " + classes.modalSignup
          }}
          open={this.props.isOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose("AddOportunityModal")}
          aria-labelledby="signup-modal-slide-title"
          aria-describedby="signup-modal-slide-description"
        >
          <Card plain className={classes.modalSignupCard}>
            <DialogTitle
              id="signup-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
            >
              <Button
                simple
                className={classes.modalCloseButton}
                key="close"
                aria-label="Close"
                onClick={() => this.props.handleClose("AddOportunityModal")}
              >
                {" "}
                <Close className={classes.modalClose} />
              </Button>
              <h5 className={`${classes.cardTitle} ${classes.modalTitle}`}>
                Create oportunity
              </h5>
            </DialogTitle>
            <DialogContent
              id="signup-modal-slide-description"
              className={classes.modalBody}
            >
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} className={classes.mlAuto}>
                  <AddContactStepper confirm={this.props.confirm}/>

                </GridItem>
              </GridContainer>
            </DialogContent>
          </Card>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(javascriptStyles)(AddOportunity);
